// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Bj-tabs[data-v-78b084aa] {\n  position: relative;\n}\n.Bj-tabs .right[data-v-78b084aa] {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 40px;\n  line-height: 40px;\n  z-index: 1;\n}", ""]);
// Exports
module.exports = exports;
